import { IActor, IHomeClubReviewData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import owner from './owner';
import { IContentItemHomeClubReview } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class HomeClubReview {
  clubId: number;
  clubImg: string;
  clubName: string;
  description: string;
  owner: IActor;
  seoURL?: string;
  approvalState?: string;
  clubVisibility?: string;

  constructor() {
    this.clubId = -1;
    this.clubImg = '';
    this.clubName = '';
    this.description = '';
    this.owner = {};
    this.seoURL = '';
    this.approvalState = '';
    this.clubVisibility = '';
  }

  static mappingObject(_obj: IHomeClubReviewData): IContentItemHomeClubReview {
    let obj = Object.assign(new HomeClubReview(), _obj);
    obj.clubId = _obj.ID || -1;
    obj.clubImg = _obj.ImgUrl || '';
    obj.clubName = _obj.Title || '';
    obj.description = _obj.Message || '';
    obj.owner = _obj.Owner ? owner.mappingObject(_obj.Owner) : {};
    obj.seoURL = _obj.SEOUrl || '';
    obj.approvalState = _obj.ApprovalState || '';
    obj.clubVisibility = _obj.ClubVisibility || '';
    obj = utils.cleanObjectKeys(Object.keys(new HomeClubReview()), obj);
    return obj;
  }
}
